import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function VillainSection() {
  return <section className="py-4 md:py-14 px-6 bg-white border-y border-navy/5" data-id="element-359">
      <div className="max-w-3xl mx-auto text-center" data-id="element-360">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 mb-6" data-id="element-361">
          <ShieldAlert className="w-8 h-8 text-red-500" data-id="element-362" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-navy mb-8" data-id="element-363">
          No es tu culpa.
        </h2>

        <div className="text-lg md:text-xl text-navy/80 leading-relaxed space-y-6 text-left bg-background p-8 md:p-10 rounded-2xl shadow-sm" data-id="element-364">
          <p data-id="element-365">
            Has estado siguiendo el{' '}
            <strong className="text-navy" data-id="element-366">"Manual de Instrucciones"</strong> que
            te dio la industria. Ese que dice que{' '}
            <strong className="text-navy" data-id="element-367">
              las calorías son lo único que importa
            </strong>
            , que la grasa es el demonio y que tenés que comer{' '}
            <strong className="text-navy" data-id="element-368">cada 3 horas</strong> para "mantener
            el metabolismo activo".
          </p>
          <p data-id="element-369">
            Esa información está diseñada para que{' '}
            <strong className="text-navy" data-id="element-370">sigas comprando productos</strong>, no
            para que{' '}
            <span className="text-accent font-semibold" data-id="element-371">seas libre</span>.
          </p>
          <p className="font-semibold text-navy border-l-4 border-accent pl-4" data-id="element-372">
            Mientras sigas ese manual, tu{' '}
            <span className="text-accent" data-id="element-373">"Bóveda de Grasa"</span> seguirá
            cerrada bajo llave.
          </p>
        </div>
      </div>
    </section>;
}